/**
 * View component for /audit-logs/:auditLogId
 *
 * Displays a single auditLog from the 'byId' map in the auditLog reducer
 * as defined by the 'selected' property
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { Helmet } from 'react-helmet';

// import actions
import * as auditLogActions from '../auditLogActions';

// import global components
import Base from '../../../global/components/BaseComponent.js.jsx';

// import resource components
import AuditLogLayout from '../components/AuditLogLayout.js.jsx';

class SingleAuditLog extends Base {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const { dispatch, match } = this.props;
    dispatch(auditLogActions.fetchSingleIfNeeded(match.params.auditLogId));
  }

  render() {
    const { auditLogStore } = this.props;

    /**
     * use the selected.getItem() utility to pull the actual auditLog object from the map
     */
    const selectedAuditLog = auditLogStore.selected.getItem();

    const isEmpty = (
      !selectedAuditLog
      || !selectedAuditLog._id
      || auditLogStore.selected.didInvalidate
    );

    const isFetching = (
      auditLogStore.selected.isFetching
    )

    return (
      <AuditLogLayout>
        <Helmet
          title={"Single Audit Log | Pro-ficiency"}
        />
        <h3> Single Audit Log </h3>
        { isEmpty ?
          (isFetching ? <h2>Loading...</h2> : <h2>Empty.</h2>)
          :
          <div style={{ opacity: isFetching ? 0.5 : 1 }}>
            <h1> { selectedAuditLog.name }
            </h1>
            <hr/>
            <p> <em>Other characteristics about the AuditLog would go here.</em></p>
            <br/>
            <Link to={`${this.props.match.url}/update`}> Update Audit Log </Link>
          </div>
        }
      </AuditLogLayout>
    )
  }
}

SingleAuditLog.propTypes = {
  dispatch: PropTypes.func.isRequired
}

const mapStoreToProps = (store) => {
  /**
  * NOTE: Yote refer's to the global Redux 'state' as 'store' to keep it mentally
  * differentiated from the React component's internal state
  */
  return {
    auditLogStore: store.auditLog
  }
}

export default withRouter(
  connect(
    mapStoreToProps
  )(SingleAuditLog)
);



// WEBPACK FOOTER //
// modules/auditLog/views/SingleAuditLog.js.jsx